//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import { FormInput } from '@/components/Form'
import Button from '@/components/Shared/Button'
import { rutFilter } from 'vue-dni'

export default {
  name: 'MagicLinkFormModal',
  components: {
    FormInput,
    ValidationObserver,
    Button,
    ModalWithTitleBar,
  },
  props: {
    title: {
      type: String,
      default: 'Inicia Sesión con enlace',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    countries: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        country: null,
        rut: null,
        identification_number: null,
      },
      isValidForm: false,
      rutCountry: 'Chile',
    }
  },
  watch: {
    form: {
      handler() {
        this.handleChangeForm()
        this.form.rut = this.form.rut ? rutFilter(this.form.rut) : null
      },
      deep: true,
    },
  },
  methods: {
    cancel() {
      this.resetForm()
      this.$emit('cancel')
    },
    submit() {
      if (!this.isValidForm) {
        return
      }

      if (this.form.rut) {
        this.$emit('submit', this.form.rut)
      } else if (this.form.identification_number) {
        this.$emit('submit', this.form.identification_number)
      }

      this.resetForm()
    },
    async handleChangeForm() {
      if (
        this.form.country &&
        (this.form.rut || this.form.identification_number)
      ) {
        this.isValidForm = await this.$refs.magicLinkIdentificationFormObserver.validate()
      }
    },
    resetForm() {
      this.form = {
        country: null,
        rut: null,
        identification_number: null,
      }
      this.isValidForm = false
    },
    handleCleanForm() {
      this.form.rut = null
      this.form.identification_number = null
      this.isValidForm = false
    },
  },
}
